<pm-modal ShowModal="ShowModal" 
          (OnClosed)="Close(undefined)" 
          [Header]="Header"
          BodyWidthPx="400"
          BodyHeightPx="160"
          CanResize="false">
    <div style="background-color: white; padding: 4px;display: flex; flex-direction:column; height: 100%;">
        <div  style="flex-grow: 1; display: flex; justify-content: center; align-items: center;">
            <pm-icon-exclamation-triangle style="padding: 20px;" IconSize="4" IconClass="icon-orange"></pm-icon-exclamation-triangle>
            <div class="controls-header layout-flex-fill">{{Content}}</div>
        </div>
        <div class="layout-flex">
            <pm-button class="flex-align-right" style="padding-left: 5px; margin-top:0px; margin-bottom:0px" (click)="Close(undefined)">Close</pm-button>
        </div>
    </div>
</pm-modal>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/services/dialog/alert-dialog.html